<template>
  <div class="history">
    <div class="wrapper">
      <p class="pub-title">发展历程</p>
      <p class="pub-sub-title">development path</p>
      <div class="box pc">
        <div class="btn" @click="developmentPrev">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div
          class="swiper"
          id="devolopment-box"
          @mouseup="mouseup"
          @mousemove="mousemove"
          @mousedown="mousedown"
        >
          <template v-for="(item, index) in list">
            <div class="slide" v-if="(index + 1) % 2 !== 0">
              <div class="top">
                <p class="title">{{ item.year }}</p>
                <p class="desc">{{ item.intro }}</p>
                <div class="hr"></div>
              </div>
              <div class="bottom"></div>
            </div>
            <div class="slide" v-else>
              <div class="top"></div>
              <div class="bottom">
                <div class="hr"></div>
                <p class="title">{{ item.year }}</p>
                <p class="desc">{{ item.intro }}</p>
              </div>
            </div>
          </template>
        </div>
        <div class="btn" @click="developmentNext">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="box mobile">
        <div class="btn" @click="prev">
          <i class="el-icon-arrow-left"></i>
        </div>
        <swiper class="mobile-swiper" ref="siwper" :options="options">
          <swiper-slide v-for="(item, index) in list">
            <p class="mobile-swiper-title">{{ item.year }}</p>
            <p class="mobile-swiper-desc">{{ item.intro }}</p>
          </swiper-slide>
        </swiper>
        <div class="btn" @click="next">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let timer = null,
  dragSwitch = false,
  x = 0
import { development_path } from '../../utils/api'
export default {
  data() {
    return {
      list: [],
      options: {
        autoHeight: true,
        // centeredSlides: true,
        // spaceBetween: 30,
      },
    }
  },
  mounted() {
    development_path((e) => {
      this.list = e.data
    })
  },
  methods: {
    developmentNext() {
      clearInterval(timer)
      timer = null
      let dom = document.getElementById('devolopment-box')
      let i = 0
      timer = setInterval(() => {
        dom.scrollTo(dom.scrollLeft + 1, 0)
        i++
        if (i >= 240) {
          clearInterval(timer)
        }
      }, 1)
    },

    prev() {
      this.$refs.siwper.swiper.slidePrev()
    },
    next() {
      this.$refs.siwper.swiper.slideNext()
    },
    mousedown(e) {
      dragSwitch = true
      x = e.clientX || e.x || e.pageX
    },
    mousemove(e) {
      if (dragSwitch) {
        let dom = document.getElementById('devolopment-box')
        let cX = x - e.clientX || e.x || e.pageX
        dom.scrollTo(dom.scrollLeft + cX, 0)
        x = e.clientX || e.x || e.pageX
      }
    },
    mouseup() {
      x = 0
      dragSwitch = false
    },
    developmentPrev() {
      clearInterval(timer)
      timer = null
      let dom = document.getElementById('devolopment-box')
      let i = 240
      timer = setInterval(() => {
        dom.scrollTo(dom.scrollLeft - 1, 0)
        i--
        if (i <= 0) {
          clearInterval(timer)
        }
      }, 1)
    },
  },
}
</script>

<style lang="less" scoped >
.history {
  padding: 80px 0;
  background-size: cover;
  background: url('../../assets/history-bg.png') no-repeat;
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .pub-sub-title {
      margin-bottom: 40px;
    }
    .box {
      display: flex;
      align-items: center;
      width: 100%;
      height: 250px;
      .btn {
        width: 80px;
        height: 80px;
        background: #ffffff;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.15s linear;
        border-radius: 50%;
        font-size: 32px;
      }
      .btn:active {
        opacity: 0.78;
      }
      .btn:hover {
        background: #006C8F;
        color: white;
      }
      .swiper::-webkit-scrollbar {
        display: none;
      }
      .swiper {
        scrollbar-width: none;
      }
      .swiper {
        -ms-overflow-style: none;
      }
      .swiper {
        width: calc(100% - 160px);
        margin: 0 40px;
        overflow-x: auto;
        font-size: 0;
        white-space: nowrap;
        user-select: none;
      }
      .slide::after {
        border-bottom: 1px solid #575757;
        width: 100%;
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: 0;
      }
      .slide::before {
        width: 10px;
        height: 10px;
        background: #006C8F;
        border: 1px solid #ffffff;
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 1;
      }
      .slide {
        height: 250px;
        display: inline-block;
        vertical-align: middle;
        padding-right: 40px;
        position: relative;
        padding-left: 5px;
        .title {
          font-size: 30px;
          font-family: DIN;
          font-weight: 400;
          line-height: 22px;
          color: #006C8F;
          margin-bottom: 10px;
        }
        .desc::-webkit-scrollbar {
          width: 2px;
          background-color: transparent;
        }

        .desc::-webkit-scrollbar-track {
          border-radius: 10px;
        }

        .desc::-webkit-scrollbar-thumb {
          border-radius: 2px;
          background: #006C8F;
        }
        .desc {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 22px;
          color: #1a1a1a;
          width: 250px;
          word-break: break-all;
          white-space: normal;
          height: 50px;
          overflow-y: auto;
        }
        .hr {
          width: 0px;
          height: 40px;
          border-right: 1px solid #979797;
        }
        & > div {
          height: 50%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          padding: 5px 0;
        }
        & > div.top {
          justify-content: flex-end;
          .hr {
            margin-top: 10px;
          }
        }
        & > div.bottom {
          justify-content: flex-start;
          .hr {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .history {
    padding: 0.68rem 0;
    background-image: url('../../assets/history-bg1.png');
    background-size: cover;
    .wrapper {
      .box {
        padding: 0 0.22rem;
        box-sizing: border-box;
        .btn {
          width: 0.92rem;
          height: 0.92rem;
          font-size: 0.48rem;
        }
        .mobile-swiper {
          width: calc(100% - 2.2rem);
          .mobile-swiper-title {
            text-align: center;
            font-size: 0.6rem;
            font-family: DIN;
            font-weight: 400;
            color: #006C8F;
            margin-bottom: 0.24rem;
          }
          .mobile-swiper-desc {
            font-size: 0.28rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1a1a1a;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>